/* global host */
/* global layer */
import modalList from '../../reimburseManage/reimbursement/view/modalList.html'
import modalUploadList from '../../reimburseManage/reimbursement/view/modalUploadList.html'
import modalUploadListAsync from '../../reimburseManage/reimbursement/view/modalUploadListAsync.html'
import modalInvoiceDetailTmplate from '../../reimburseManage/reimbursement/view/modalInvoiceDetail.html'
import manuallyImportModal from './view/manuallyImportModal.html'
import flightinforDetailModal from './view/flightinforDetailModal.html'
import utils from 'utils'
import angular from 'angular'
import updateMonthModal from '../management/view/updateMonthModal.html'

class collectionListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, initSortService, exportSettingService, getOvatAmtService, resultTipService, $location) {
        $scope.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
        const currentRoutAddress = JSON.parse(sessionStorage.getItem('currentRoutAddress'))
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        }
        $scope.invoiceDropdownConfig = {
            btnText: '发票录入',
            options: [
                {
                    text: '扫描仪录入',
                    hasPermit: 'invoice_import',
                    handler() {
                        $scope.uploadFiles(1)
                    },
                },
                {
                    text: '扫描枪录入',
                    hasPermit: 'invoice_import',
                    handler() {
                        $scope.uploadFiles(4)
                    },
                },
                {
                    text: '手工录入',
                    hasPermit: 'invoice_import',
                    handler() {
                        $scope.manuallyImport()
                    },
                },
                {
                    text: '本地上传',
                    hasPermit: 'invoice_import',
                    handler() {
                        $scope.uploadFiles(2)
                    },
                },
                {
                    text: '异步上传',
                    hasPermit: 'invoice_import',
                    handler() {
                        $scope.uploadFiles(5)
                    },
                },
            ],
        }
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量校对',
                    // hasPermit: 'invoice_proofread',
                    handler() {
                        $scope.batchProofread()
                    },
                },
                {
                    text: '批量删除',
                    // hasPermit: 'invoice_collect_delete',
                    handler() {
                        $scope.batchDelete()
                    },
                },
                {
                    text: '批量提交',
                    // hasPermit: 'collection_submit',
                    handler() {
                        $scope.batchSubmit()
                    },
                },
                {
                    text: '批量查验',
                    handler() {
                        $scope.check()
                    },
                },
            ],
        }
        function get_dictByTypeArr() {
            return httpRequest.get_dictByTypeArr(['ivat_inv_type', 'verify_status', 'deduction_flag', 'expense_usage_status', 'ivat_invoice_status', 'ivat_invoice_source', 'is_received', 'ovat_tax_rate', 'ivat_common_flag', 'proofread_status', 'ivat_bill_source', 'ivat_inv_add_type', 'interface_invoice_status', 'interface_source_system', 'department_no', 'ivat_comparison_status', 'ivat_source_app_id']).then((res) => {
                return res.data.value
            })
        }
        //所属大区
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 获取主管税局省（市）
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // 联动查询出管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                return v.enumName === enumName
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                return v.regionName === enumName
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }

        // 所选择的机构名称
        $scope.handleOrgChange = function (orgData) {
            //重置
            $scope.orgIdListArr.length = 0
            if (orgData.length > 0) {
                angular.forEach(orgData, function (item, index) {
                    $scope.orgIdListArr.push(item.orgId)
                })
                $scope.param.param.orgIdList = $scope.orgIdListArr
            } else {
                $scope.orgIdListArr = []
                $scope.param.param.orgIdList = $scope.orgIdListArr
            }
        }
        httpRequest.get_getProjectlistOfCurrentOrg().then((res) => {
            $scope.projectList = res.data.value
        })
        httpRequest
            .get_getIvatRuleConfList({
                ruleType: 'zclx',
            })
            .then((res) => {
                $scope.ivatRuleList = res.data.value
                $scope.ivatRuleList.forEach((ele) => {
                    ele.enumName = ele.ruleName
                    ele.enumCode = ele.ruleConfId
                })
            })
        $scope.exportSetting = function () {
            exportSettingService('106', $scope.exportConfig)
        }
        $scope.exportConfig = {
            version: 1.31,
            invoiceType: [],
            splitBillFlag: [],
            mainInfo: [
                {
                    label: '票据种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方税号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方地址电话',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方银行账号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '合计金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方税号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方地址电话',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方银行账号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '校验码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '收款人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '复核人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '收票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '抵扣标志',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '抵扣属期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '转出属期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '转出类型',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '客运标志',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '业务单据号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '方式/人员',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '状态比对',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数电票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '来源系统编码',
                    selected: true,
                    defaultWord: true,
                },
            ],
            detailInfo: [
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '票据种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方地址电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方开户行及账号',
                    selected: false,
                    defaultWord: false,
                },
            ],
        }
        $scope.active = sessionStorage.activeParam ? +JSON.parse(sessionStorage.activeParam) : 1
        $scope.exportCollapsed = false
        $scope.profileTypeObj = {
            version: 5.51,
        }
        let paramStr = 'collectionParam'
        const queryConfig = [
            {
                label: '票据种类',
                selected: true,
                default: true,
            },
            {
                label: '发票代码',
                selected: true,
                default: true,
            },
            {
                label: '发票号码',
                selected: true,
                default: true,
            },
            {
                label: '开票日期',
                selected: true,
                default: true,
            },
            {
                label: '查验结果',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
            },
            {
                label: '录入时间',
                selected: false,
                default: false,
            },
            {
                label: '发票状态',
                selected: false,
                default: false,
            },
            {
                label: '获取方式',
                selected: false,
                default: false,
            },
            {
                label: '销方名称',
                selected: false,
                default: false,
            },
            {
                label: '销方税号',
                selected: false,
                default: false,
            },
            {
                label: '姓名',
                selected: false,
                default: false,
            },
            {
                label: '目的地',
                selected: false,
                default: false,
            },
            {
                label: '出发地',
                selected: false,
                default: false,
            },
            {
                label: '抵扣标志',
                selected: false,
                default: false,
            },
            {
                label: '客运标志',
                selected: false,
                default: false,
            },
            {
                label: '项目名称',
                selected: false,
                default: false,
            },
            {
                label: '项目编号',
                selected: false,
                default: false,
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
            },
            {
                label: '进项转出标志',
                selected: false,
                default: false,
            },
            {
                label: '进项转出金额',
                selected: false,
                default: false,
            },
            {
                label: '报销状态',
                selected: false,
                default: false,
            },
            {
                label: '关联单据号',
                selected: false,
                default: false,
            },
            {
                label: '凭证号',
                selected: false,
                default: false,
            },
            {
                label: '来源系统',
                selected: false,
                default: false,
            },
            {
                label: '机构名称',
                selected: false,
                default: false,
            },
            {
                label: '事业部',
                selected: false,
                default: false,
            },
            {
                label: '所属大区',
                selected: false,
                default: false,
            },
            {
                label: '管理城市',
                selected: false,
                default: false,
            },
            {
                label: '主管税局所在省市',
                selected: false,
                default: false,
            },
            {
                label: '状态比对',
                selected: false,
                default: false,
            },
            {
                label: '数电票号码',
                selected: false,
                default: false,
            },
            {
                label: '来源系统编码',
                selected: false,
                default: false,
            },
        ]
        const queryConfig2 = {
            splitBillFlag: true,
            commonField: [
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '税率',
                    selected: false,
                    default: false,
                },
                {
                    label: '价税合计',
                    selected: true,
                    default: true,
                },
                {
                    label: '录入人员',
                    selected: false,
                    default: false,
                },

                {
                    label: '录入方式',
                    selected: false,
                    default: false,
                },
                {
                    label: '抵扣标志',
                    selected: false,
                    default: false,
                },
                {
                    label: '客运标志',
                    selected: false,
                    default: false,
                },
                {
                    label: '业务单据号',
                    selected: false,
                    default: false,
                },
                {
                    label: '收票状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '转出类型',
                    selected: false,
                    default: false,
                },
                {
                    label: '转出属期',
                    selected: false,
                    default: false,
                },
                {
                    label: '抵扣属期',
                    selected: false,
                    default: false,
                },
                {
                    label: '录入时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '项目名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '项目编号',
                    selected: false,
                    default: false,
                },
                {
                    label: '进项转出标志',
                    selected: false,
                    default: false,
                },
                {
                    label: '进项转出金额',
                    selected: false,
                    default: false,
                },
                {
                    label: '报销状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '关联单据号',
                    selected: false,
                    default: false,
                },
                {
                    label: '凭证号',
                    selected: false,
                    default: false,
                },
                {
                    label: '来源系统',
                    selected: false,
                    default: false,
                },
                {
                    label: '机构名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '事业部',
                    selected: false,
                    default: false,
                },
                {
                    label: '所属大区',
                    selected: false,
                    default: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    default: false,
                },
                {
                    label: '主管税局所在省市',
                    selected: false,
                    default: false,
                },
                {
                    label: '数电票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
            valueAddedTaxField: [
                {
                    label: '票据种类',
                    selected: false,
                    default: false,
                },
                {
                    label: '销方名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '发票状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '状态比对',
                    selected: false,
                    default: false,
                },
                {
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
            otherInvoiceField: [
                {
                    label: '姓名',
                    selected: false,
                    default: false,
                },
                {
                    label: '目的地',
                    selected: false,
                    default: false,
                },
                {
                    label: '出发地',
                    selected: false,
                    default: false,
                },
                {
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
        }
        const table = [
            {
                label: '查验结果',
                selected: true,
                default: true,
            },
            {
                label: '发票类型',
                selected: true,
                default: true,
            },
            {
                label: '发票号码',
                selected: true,
                default: true,
            },
            {
                label: '发票代码',
                selected: false,
                default: false,
            },
            {
                label: '开票日期',
                selected: true,
                default: true,
            },
            {
                label: '发票金额',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '发票税额',
                selected: false,
                default: false,
            },
            {
                label: '价税合计',
                selected: true,
                default: true,
            },
            {
                label: '发票状态',
                selected: false,
                default: false,
            },
            {
                label: '校验码',
                selected: false,
                default: false,
            },
            {
                label: '销方名称',
                selected: false,
                default: false,
            },
            {
                label: '销方税号',
                selected: false,
                default: false,
            },
            {
                label: '姓名',
                selected: false,
                default: false,
            },
            {
                label: '出发地',
                selected: false,
                default: false,
            },
            {
                label: '目的地',
                selected: false,
                default: false,
            },
            {
                label: '抵扣标志',
                selected: false,
                default: false,
            },
            {
                label: '客运票标志',
                selected: false,
                default: false,
            },
            {
                label: '校对状态',
                selected: true,
                default: true,
            },
            // {
            //     label: '使用状况',
            //     selected: true,
            //     default: true,
            // },
            // {
            //     label: '业务单据号',
            //     selected: false,
            //     default: false,
            // },
            {
                label: '项目名称',
                selected: false,
                default: false,
            },
            {
                label: '项目编号',
                selected: false,
                default: false,
            },
            {
                label: '获取方式',
                selected: true,
                default: true,
            },
            {
                label: '录入人员/时间',
                selected: true,
                default: true,
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
            },
            {
                label: '进项转出标志',
                selected: false,
                default: false,
            },
            {
                label: '进项转出金额',
                selected: false,
                default: false,
            },
            {
                label: '报销状态',
                selected: false,
                default: false,
            },
            {
                label: '关联单据号',
                selected: false,
                default: false,
            },
            {
                label: '凭证号',
                selected: false,
                default: false,
            },
            {
                label: '来源系统',
                selected: false,
                default: false,
            },
            {
                label: '机构名称',
                selected: false,
                default: false,
            },
            {
                label: '事业部',
                selected: false,
                default: false,
            },
            {
                label: '所属大区',
                selected: false,
                default: false,
            },
            {
                label: '管理城市',
                selected: false,
                default: false,
            },
            {
                label: '主管税局所在省市',
                selected: false,
                default: false,
            },
            {
                label: '状态比对',
                selected: false,
                default: false,
            },
            {
                label: '数电票号码',
                selected: false,
                default: false,
            },
            {
                label: '入账月份',
                selected: false,
                default: false,
            },
            {
                label: '来源系统编码',
                selected: false,
                default: false,
            },
        ]

        /********************************************************************************* */
        // 票据拆分的初始化
        function initSpilitBillType() {
            $scope.billType = '1' // 初始为增值税发票
            $scope.ifFlodBillTypeBox = true // 票据类型选择框初始为折叠状态

            // 票据类型框中票据
            $scope.billTypeSet = [
                {
                    type: 1,
                    label: '增值税发票',
                },
                {
                    type: 2,
                    label: '通用机打发票',
                },
                {
                    type: 3,
                    label: '航空运输电子客票行程单',
                },
                {
                    type: 4,
                    label: '铁路车票',
                },
                {
                    type: 5,
                    label: '公路、水路客票',
                },
                {
                    type: 6,
                    label: '出租车发票',
                },
                {
                    type: 7,
                    label: '过桥、路费发票',
                },
                {
                    type: 8,
                    label: '通用定额发票',
                },
                {
                    type: 9,
                    label: '停车费发票',
                },
                {
                    type: 10,
                    label: '机动车销售统一发票',
                },
                {
                    type: 11,
                    label: '二手车销售统一发票',
                },
                {
                    type: 12,
                    label: '医疗费用收据',
                },
                {
                    type: 13,
                    label: '教育费用收据',
                },
                {
                    type: 14,
                    label: '区块链电子发票',
                },
            ]
            // 各票据对应字段
            $scope.tableSet = {
                // 增值税发票（专、普、电、卷、通行费电子）
                1: [
                    {
                        //1
                        label: '票据种类',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceType',
                    },
                    {
                        //2
                        label: '发票代码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceCode',
                    },
                    {
                        //3
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        //4
                        label: '开票日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        //5
                        label: '销方名称',
                        selected: true,
                        default: true,
                        fieldName: 'saleName',
                    },
                    {
                        //6
                        label: '销方税号',
                        selected: false,
                        default: false,
                        fieldName: 'saleCreditCode',
                    },
                    {
                        //7
                        label: '销方地址电话',
                        selected: false,
                        default: false,
                        fieldName: 'saleAddress',
                    },
                    {
                        //8
                        label: '销方银行账号',
                        selected: false,
                        default: false,
                        fieldName: 'saleBank',
                    },
                    {
                        //9
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'totalAmt',
                    },
                    {
                        //10
                        label: '税率',
                        selected: false,
                        default: false,
                        fieldName: 'taxRate',
                    },
                    {
                        //11
                        label: '税额',
                        selected: true,
                        default: true,
                        fieldName: 'totalTaxamt',
                    },
                    {
                        //12
                        label: '价税合计',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        //13
                        label: '购方名称',
                        selected: false,
                        default: false,
                        fieldName: 'custName',
                    },
                    {
                        //14
                        label: '购方税号',
                        selected: false,
                        default: false,
                        fieldName: 'custCreditCode',
                    },
                    {
                        //15
                        label: '购方地址电话',
                        selected: false,
                        default: false,
                        fieldName: 'custAddress',
                    },
                    {
                        //16
                        label: '购方银行账号',
                        selected: false,
                        default: false,
                        fieldName: 'custBank',
                    },
                    {
                        //17
                        label: '校验码',
                        selected: false,
                        default: false,
                        fieldName: 'checkCode',
                    },
                    {
                        //18
                        label: '备注',
                        selected: false,
                        default: false,
                        fieldName: 'remark',
                    },
                    {
                        //19
                        label: '发票状态',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceStatus',
                    },
                    {
                        //20
                        label: '收票状态',
                        selected: false,
                        default: false,
                        fieldName: 'collectionStatus',
                    },
                    {
                        //21
                        label: '抵扣标志',
                        selected: false,
                        default: false,
                        fieldName: 'deductionFlag',
                    },
                    {
                        //22
                        label: '抵扣属期',
                        selected: false,
                        default: false,
                        fieldName: 'dkssq',
                    },
                    {
                        //23
                        label: '转出属期',
                        selected: false,
                        default: false,
                        fieldName: 'zcssq',
                    },
                    {
                        //24
                        label: '转出类型',
                        selected: false,
                        default: false,
                        fieldName: 'turnOutType',
                    },
                    {
                        //25
                        label: '客运标志',
                        selected: false,
                        default: false,
                        fieldName: 'passengerFlag',
                    },
                    {
                        //26
                        label: '业务单据号',
                        selected: false,
                        default: false,
                        fieldName: 'claimNumber',
                    },
                    {
                        //27
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        //28
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //29
                        label: '录入方式',
                        selected: false,
                        default: false,
                        fieldName: 'billSource',
                    },
                    {
                        //30
                        label: '人员/录入时间',
                        selected: false,
                        default: false,
                        fieldName: 'realName',
                    },
                    {
                        //31
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        //32
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //32
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //33
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //34
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //35
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '状态比对',
                        selected: false,
                        default: false,
                        fieldName: 'comparisonStatus',
                    },
                    {
                        label: '数电票号码',
                        selected: false,
                        default: false,
                        fieldName: 'electricInvoiceNum',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 通用机打发票 2
                2: [
                    {
                        label: '发票代码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceCode',
                    },
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '行业分类',
                        selected: true,
                        default: true,
                        fieldName: 'industryCategory',
                    },
                    {
                        label: '品名',
                        selected: true,
                        default: true,
                        fieldName: 'productName',
                    },
                    {
                        label: '收票状态',
                        selected: true,
                        default: true,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '业务单据号',
                        selected: true,
                        default: true,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //9
                        label: '录入方式',
                        selected: true,
                        default: true,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: true,
                        default: true,
                        fieldName: 'realName',
                    },
                    {
                        //12
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        //13
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //14
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //15
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //16
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //17
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 航空运输电子客票行程单 3
                3: [
                    {
                        label: '印刷序号',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '姓名',
                        selected: true,
                        default: true,
                        fieldName: 'userName',
                    },
                    {
                        label: '身份证件号码',
                        selected: false,
                        default: false,
                        fieldName: 'idNumber',
                    },
                    {
                        label: '行程日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '出发地',
                        selected: true,
                        default: true,
                        fieldName: 'departure',
                    },
                    {
                        label: '目的地',
                        selected: true,
                        default: true,
                        fieldName: 'destination',
                    },
                    {
                        //5
                        label: '票价',
                        selected: true,
                        default: true,
                        fieldName: 'ticketPrice',
                    },
                    {
                        //6
                        label: '民航发展基金',
                        selected: false,
                        default: false,
                        fieldName: 'constructionFee',
                    },
                    {
                        label: '燃油附加费',
                        selected: true,
                        default: true,
                        fieldName: 'fuelSurcharge',
                    },
                    {
                        //8
                        label: '其他税费',
                        selected: false,
                        default: false,
                        fieldName: 'otherTaxes',
                    },
                    {
                        label: '合计金额',
                        selected: true,
                        default: true,
                        fieldName: 'totalSum',
                    },
                    {
                        //10
                        label: '税率',
                        selected: false,
                        default: false,
                        fieldName: 'taxRate',
                    },
                    {
                        label: '税额',
                        selected: true,
                        default: true,
                        fieldName: 'totalTaxamt',
                    },
                    {
                        label: '电子客票号码',
                        selected: false,
                        default: false,
                        fieldName: 'eTicket',
                    },
                    {
                        label: '收票状态',
                        selected: false,
                        default: false,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '抵扣标志',
                        selected: false,
                        default: false,
                        fieldName: 'deductionFlag',
                    },
                    {
                        //15
                        label: '抵扣属期',
                        selected: false,
                        default: false,
                        fieldName: 'dkssq',
                    },
                    {
                        label: '转出属期',
                        selected: false,
                        default: false,
                        fieldName: 'zcssq',
                    },
                    {
                        label: '转出类型',
                        selected: false,
                        default: false,
                        fieldName: 'turnOutType',
                    },
                    {
                        label: '客运标志',
                        selected: false,
                        default: false,
                        fieldName: 'passengerFlag',
                    },
                    {
                        label: '业务单据号',
                        selected: false,
                        default: false,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: false,
                        default: false,
                        fieldName: 'billSource',
                    },
                    {
                        //
                        label: '人员/录入时间',
                        selected: false,
                        default: false,
                        fieldName: 'realName',
                    },
                    {
                        //
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        //
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    }, 
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 铁路车票 & 公路、水路发票 4 5
                4: [
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '姓名',
                        selected: true,
                        default: true,
                        fieldName: 'userName',
                    },
                    {
                        //3
                        label: '身份证件号码',
                        selected: false,
                        default: false,
                        fieldName: 'idNumber',
                    },
                    {
                        label: '日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '出发地',
                        selected: true,
                        default: true,
                        fieldName: 'departure',
                    },
                    {
                        label: '目的地',
                        selected: true,
                        default: true,
                        fieldName: 'destination',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '税率',
                        selected: false,
                        default: false,
                        fieldName: 'taxRate',
                    },
                    {
                        label: '税额',
                        selected: true,
                        default: true,
                        fieldName: 'totalTaxamt',
                    },
                    {
                        //10
                        label: '收票状态',
                        selected: false,
                        default: false,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '抵扣标志',
                        selected: false,
                        default: false,
                        fieldName: 'deductionFlag',
                    },
                    {
                        label: '抵扣属期',
                        selected: false,
                        default: false,
                        fieldName: 'dkssq',
                    },
                    {
                        label: '转出属期',
                        selected: false,
                        default: false,
                        fieldName: 'zcssq',
                    },
                    {
                        label: '转出类型',
                        selected: false,
                        default: false,
                        fieldName: 'turnOutType',
                    },
                    {
                        //15
                        label: '客运标志',
                        selected: false,
                        default: false,
                        fieldName: 'passengerFlag',
                    },
                    {
                        label: '业务单据号',
                        selected: false,
                        default: false,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //19
                        label: '录入方式',
                        selected: false,
                        default: false,
                        fieldName: 'billSource',
                    },
                    {
                        //20
                        label: '人员/录入时间',
                        selected: false,
                        default: false,
                        fieldName: 'realName',
                    },
                    {
                        //21
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        //22
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //23
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //24
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //25
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //26
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        // 32
                        label: '座席',
                        selected: false,
                        default: false,
                        fieldName: 'seatType',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 出租车发票 6
                6: [
                    {
                        label: '发票代码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceCode',
                    },
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '出发地',
                        selected: true,
                        default: true,
                        fieldName: 'departure',
                    },
                    {
                        label: '目的地',
                        selected: true,
                        default: true,
                        fieldName: 'destination',
                    },
                    {
                        label: '上车时间',
                        selected: true,
                        default: true,
                        fieldName: 'getTime',
                    },
                    {
                        label: '下车时间',
                        selected: true,
                        default: true,
                        fieldName: 'offTime',
                    },
                    {
                        label: '收票状态',
                        selected: true,
                        default: true,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '业务单据号',
                        selected: true,
                        default: true,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: true,
                        default: true,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: true,
                        default: true,
                        fieldName: 'realName',
                    },
                    {
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '车号',
                        selected: false,
                        default: false,
                        fieldName: 'plateNum',
                    },
                    {
                        label: '里程',
                        selected: false,
                        default: false,
                        fieldName: 'mileage',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 过桥、路费发票 7
                7: [
                    {
                        label: '发票代码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceCode',
                    },
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '开票日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '入口',
                        selected: true,
                        default: true,
                        fieldName: 'entrance',
                    },
                    {
                        label: '出口',
                        selected: true,
                        default: true,
                        fieldName: 'exit',
                    },
                    {
                        label: '车型',
                        selected: true,
                        default: true,
                        fieldName: 'vehicleType',
                    },
                    {
                        label: '收票状态',
                        selected: true,
                        default: true,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '业务单据号',
                        selected: true,
                        default: true,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: true,
                        default: true,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: true,
                        default: true,
                        fieldName: 'realName',
                    },
                    {
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 通用定额发票 8
                8: [
                    {
                        label: '发票代码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceCode',
                    },
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'oneAmount',
                    },
                    {
                        label: '份数',
                        selected: true,
                        default: true,
                        fieldName: 'number',
                    },
                    {
                        label: '总额',
                        selected: true,
                        default: true,
                        fieldName: 'totalSum',
                    },
                    {
                        label: '收票状态',
                        selected: true,
                        default: true,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '业务单据号',
                        selected: true,
                        default: true,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: true,
                        default: true,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: true,
                        default: true,
                        fieldName: 'realName',
                    },
                    {
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 停车费发票 9
                9: [
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '开始时间',
                        selected: true,
                        default: true,
                        fieldName: 'getTime',
                    },
                    {
                        label: '结束时间',
                        selected: true,
                        default: true,
                        fieldName: 'offTime',
                    },
                    {
                        label: '车牌号',
                        selected: true,
                        default: true,
                        fieldName: 'plateNumber',
                    },
                    {
                        label: '收票状态',
                        selected: true,
                        default: true,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '业务单据号',
                        selected: true,
                        default: true,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: true,
                        default: true,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: true,
                        default: true,
                        fieldName: 'realName',
                    },
                    {
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 机动车、二手车销售统一发票 10 11
                10: [
                    {
                        //1
                        label: '发票代码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceCode',
                    },
                    {
                        label: '发票号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '开票日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '销方单位名称',
                        selected: true,
                        default: true,
                        fieldName: 'saleName',
                    },
                    {
                        //5
                        label: '销方税号',
                        selected: false,
                        default: false,
                        fieldName: 'saleCreditCode',
                    },
                    {
                        //6
                        label: '销方地址',
                        selected: false,
                        default: false,
                        fieldName: 'saleAddress',
                    },
                    {
                        //7
                        label: '销方电话',
                        selected: false,
                        default: false,
                        fieldName: 'salePhone',
                    },
                    {
                        //8
                        label: '销方开户银行',
                        selected: false,
                        default: false,
                        fieldName: 'saleBank',
                    },
                    {
                        //9
                        label: '销方账号',
                        selected: false,
                        default: false,
                        fieldName: 'saleBankAccount',
                    },
                    {
                        //10
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'totalAmt',
                    },
                    {
                        label: '税率',
                        selected: false,
                        default: false,
                        fieldName: 'taxRate',
                    },
                    {
                        label: '税额',
                        selected: true,
                        default: true,
                        fieldName: 'totalTaxamt',
                    },
                    {
                        label: '价税合计',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '购方名称',
                        selected: false,
                        default: false,
                        fieldName: 'custName',
                    },
                    {
                        //15
                        label: '购方税号',
                        selected: false,
                        default: false,
                        fieldName: 'custCreditCode',
                    },
                    {
                        label: '完税凭证号码', //10机动车为'完税凭证号码'、11二手车为'备注'
                        selected: false,
                        default: false,
                        fieldName: 'proofNumber',
                    },
                    {
                        label: '发票状态',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceStatus',
                    },
                    {
                        label: '收票状态',
                        selected: false,
                        default: false,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '抵扣标志',
                        selected: false,
                        default: false,
                        fieldName: 'deductionFlag',
                    },
                    {
                        //20
                        label: '抵扣属期',
                        selected: false,
                        default: false,
                        fieldName: 'dkssq',
                    },
                    {
                        label: '转出属期',
                        selected: false,
                        default: false,
                        fieldName: 'zcssq',
                    },
                    {
                        label: '转出类型',
                        selected: false,
                        default: false,
                        fieldName: 'turnOutType',
                    },
                    {
                        label: '业务单据号',
                        selected: false,
                        default: false,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: false,
                        default: false,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: false,
                        default: false,
                        fieldName: 'realName',
                    },
                    {
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    }, 
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
                // 医疗费用收据、教育费用收据 12 13
                12: [
                    {
                        label: '收据号码',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceNumber',
                    },
                    {
                        label: '日期',
                        selected: true,
                        default: true,
                        fieldName: 'invoiceDate',
                    },
                    {
                        label: '姓名',
                        selected: true,
                        default: true,
                        fieldName: 'userName',
                    },
                    {
                        label: '金额',
                        selected: true,
                        default: true,
                        fieldName: 'adValoremTotal',
                    },
                    {
                        label: '收票状态',
                        selected: true,
                        default: true,
                        fieldName: 'collectionStatus',
                    },
                    {
                        label: '业务单据号',
                        selected: true,
                        default: true,
                        fieldName: 'claimNumber',
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                        fieldName: 'projectName',
                    },
                    {
                        label: '项目编号',
                        selected: false,
                        default: false,
                        fieldName: 'projectCode',
                    },
                    {
                        //27
                        label: '录入方式',
                        selected: true,
                        default: true,
                        fieldName: 'billSource',
                    },
                    {
                        //9
                        label: '人员/录入时间',
                        selected: true,
                        default: true,
                        fieldName: 'realName',
                    },
                    {
                        label: '进项转出标志',
                        selected: false,
                        default: false,
                        fieldName: 'transferOutSign',
                    },
                    {
                        label: '进项转出金额',
                        selected: false,
                        default: false,
                        fieldName: 'transferAmount',
                    },
                    {
                        //
                        label: '报销状态',
                        selected: false,
                        default: false,
                        fieldName: 'reimbursementStatus',
                    },
                    {
                        //
                        label: '关联单据号',
                        selected: false,
                        default: false,
                        fieldName: 'statementNumber',
                    },
                    {
                        //
                        label: '凭证号',
                        selected: false,
                        default: false,
                        fieldName: 'voucherNumber',
                    },
                    {
                        //
                        label: '来源系统',
                        selected: false,
                        default: false,
                        fieldName: 'sourceSystem',
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                        fieldName: 'orgId',
                    },
                    {
                        label: '事业部',
                        selected: false,
                        default: false,
                        fieldName: 'departmentNo',
                    },
                    {
                        label: '所属大区',
                        selected: false,
                        default: false,
                        fieldName: 'regionName',
                    },
                    {
                        label: '管理城市',
                        selected: false,
                        default: false,
                        fieldName: 'cityName',
                    },
                    {
                        label: '主管税局所在省市',
                        selected: false,
                        default: false,
                        fieldName: 'province',
                    },
                    {
                        label: '入账月份',
                        selected: false,
                        default: false,
                        fieldName: 'paymentMonth',
                    },
                    {
                        label: '来源系统编码',
                        selected: false,
                        default: false,
                        fieldName: 'sourceAppId',
                    },
                ],
            }
            $scope.tableSet['5'] = [...$scope.tableSet['4']]
            $scope.tableSet['5'].unshift({
                label: '发票代码',
                selected: true,
                default: true,
                fieldName: 'invoiceCode',
            })
            let index = $scope.tableSet['5'].findIndex((item) => item.label == '座席')
            $scope.tableSet['5'].splice(index, 1)
            $scope.tableSet['11'] = [...$scope.tableSet['10']]
            $scope.tableSet['11'][15] = {
                label: '备注', //10机动车为完税凭证号码、11二手车为备注
                selected: false,
                default: false,
                fieldName: 'remark',
            }
            $scope.tableSet['13'] = [...$scope.tableSet['12']]
            $scope.tableSet['14'] = [...$scope.tableSet['1']]
            let comparisonStatusIndex = $scope.tableSet['14'].findIndex((item) => item.fieldName == 'comparisonStatus')
            $scope.tableSet['14'].splice(comparisonStatusIndex, 1)
            // 当前票据类型字段arr
            $scope.currentTable = $scope.tableSet[1]
            $scope.profileTypeObj.table = $scope.tableSet[1].map((item) => {
                return {
                    label: item.label,
                    selected: item.selected,
                    default: item.default,
                }
            })
            // 票据对应查询参数
            $scope.billParamSet = {
                1: {
                    invoiceTypeList: [0, 2, 51, 41, 14, '08', 61, 62, 67, 66],
                    profileType: 120,
                },
                2: {
                    invoiceTypeList: [107],
                    profileType: 128,
                },
                3: {
                    invoiceTypeList: [102],
                    profileType: 122,
                },
                4: {
                    invoiceTypeList: [103],
                    profileType: 123,
                },
                5: {
                    invoiceTypeList: [104],
                    profileType: 124,
                },
                6: {
                    invoiceTypeList: [106],
                    profileType: 125,
                },
                7: {
                    invoiceTypeList: [101],
                    profileType: 127,
                },
                8: {
                    invoiceTypeList: [105],
                    profileType: 121,
                },
                9: {
                    invoiceTypeList: [108],
                    profileType: 126,
                },
                10: {
                    invoiceTypeList: [12],
                    profileType: 132,
                },
                11: {
                    invoiceTypeList: [15],
                    profileType: 131,
                },
                12: {
                    invoiceTypeList: [109],
                    profileType: 129,
                },
                13: {
                    invoiceTypeList: [110],
                    profileType: 130,
                },
                14: {
                    invoiceTypeList: [111],
                    profileType: 111,
                },
            }
        }
        initSpilitBillType()
        // 点击票据类型
        $scope.billTypeChange = function billTypeChange(type) {
            $scope.billType = type
            $scope.profileType = $scope.billParamSet[type].profileType
            $scope.currentTable = $scope.tableSet[type]
            $scope.profileTypeObj.table = $scope.tableSet[type].map((item) => {
                return {
                    label: item.label,
                    selected: item.selected,
                    default: item.default,
                }
            })
            // $scope.orderMap = {}
            $scope.param.param.invoiceTypeList = $scope.billParamSet[type].invoiceTypeList
            $scope.handleExportField()
            $scope.queryTaxInfo()
        }
        // 票种导出字段设置
        $scope.handleExportField = () => {
            const { mainInfo } = $scope.exportConfig
            let comparisonStatusIndex = mainInfo.findIndex((item) => item.fieldName == '状态比对')
            $scope.exportConfig.mainInfo.splice(comparisonStatusIndex, 1)
        }
        /********************************************************************************* */
        //机构树的check配置信息
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
                chkStyle: 'checkbox',
            },
        }
        // 获取机构
        $scope.getUserOrgList = async function () {
            httpRequest.get_getUserOrgList().then((res) => {
                // 机构勾选变化
                $scope.orgIdListArr = []
                if (res.data.success) {
                    $scope.orgList = res.data.value
                    // 展开节点及全选
                    angular.forEach($scope.orgList, function (item, index) {
                        item.open = true
                        if ($scope.currentOrgId == item.orgId) {
                            item.checked = true
                            $scope.orgIdListArr.push(item.orgId)
                            // 默认当前操作机构
                            $scope.selectedOrgList = [item]
                        }
                    })
                    $scope.param.param.orgIdList = $scope.orgIdListArr
                    // 默认全部数据
                    //   $scope.selectedOrgList = $scope.orgList;
                    // 返回机构名称
                    $scope.fliterOrgName = function (id) {
                        if (id === null) {
                            return id
                        }
                        if (res.data.value === null) {
                            return id
                        }
                        const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                        if (fliterUkeyNameArr.length > 0) {
                            return fliterUkeyNameArr[0].orgName
                        }
                        return id
                    }
                    get_dictByTypeArr().then((res) => {
                        $scope.dictData = res
                        $scope.inspectionResults(res.verify_status)
                        $scope.queryTaxInfo()
                    })
                }
            })
        }
        // $scope.getUserOrgList()
        // 对查验结果种类查询改造 适应树组件
        $scope.inspectionResults = (resultsType) => {
            // 默认查询全部查验结果种类
            let resultsTypeCode = []
            resultsType.forEach((item) => {
                item.orgName = item.enumName
                item.orgId = item.enumCode
                item.checked = true
                item.open = true
                resultsTypeCode.push(item.enumCode)
            })
            $scope.selectedResultsList = resultsType
            $scope.inspectionResultsList = resultsType
            $scope.param.param.verifyStatuList = resultsTypeCode
        }
        $scope.handleResultsChange = (resultsType) => {
            $scope.param.param.verifyStatuList = resultsType.map((item) => {
                return item.orgId
            })
        }
        // 是否全选票据种类
        $scope.resultsIsCheckAll = (resultsType) => {
            let resultsTypeListArr = []
            angular.forEach(resultsType, (item, index) => {
                resultsTypeListArr.push(item.orgId)
            })
            $scope.param.param.verifyStatuList = resultsTypeListArr
        }
        // 是否全选机构
        $scope.orgIsCheckAll = (orgList) => {
            let orgListArr = []
            angular.forEach(orgList, (item, index) => {
                orgListArr.push(item.orgId)
            })
            $scope.orgIdListArr = orgListArr
        }
        $scope.reset = function reset() {
            $scope.param.param = {
                invoiceType: '',
                invoiceCode: '',
                invoiceNumber: '',
                invoiceDateStart: '',
                invoiceDateEnd: '',
                verifyStatuList: [], // tab1
                taxRate: '',
                adValoremTotalStart: '',
                createUser: '',
                invoiceStatus: '',
                invoiceSource: '',
                saleName: '',
                saleCreditCode: '',
                userName: '',
                destination: '',
                departure: '',
                deductionFlag: '',
                passengerFlag: '',
                claimNumber: '',
                usageStatus: '',
                usagePage: $scope.active,
                collectionStatus: '', // tab2
                turnOutType: '', // tab2
                zcssq: '', // tab2
                dkssq: '', // tab2
                projectId: '',
                projectCode: '',
                transferOutSign: '',
                transferAmount: '',
                orgIdList: $scope.orgIdListArr,
                comparisonStatus: '',
                paymentDate: '',
                sourceAppId: '',
            }
            $scope.belleRegionCityList = []
            // 重置默认机构勾选
            $scope.getUserOrgList()
            $scope.$broadcast('selectedOrgList', $scope.selectedOrgList)
            $scope.$broadcast('selectedResultsList', $scope.inspectionResultsList)
        }
        // $scope.reset()
        $scope.tabChange = function tabChange(v) {
            $scope.active = v
            $scope.reset()
            if (v == 1) {
                paramStr = 'collectionParam'
                $scope.profileType = 16
                $scope.profileTypeObj.queryConfig = queryConfig
                $scope.profileTypeObj.table = table
            } else if (v == 2) {
                paramStr = 'collectionedParam'
                $scope.billType = 1 // 增值税发票的billType
                $scope.profileType = $scope.billParamSet[1].profileType // 增值税发票的profileType
                $scope.currentTable = $scope.tableSet[1] // 增值税发票的表格字段
                $scope.profileTypeObj.queryConfig = queryConfig2
                $scope.profileTypeObj.table = $scope.currentTable.map((item) => {
                    // 增值税发票的表格字段
                    return {
                        label: item.label,
                        selected: item.selected,
                        default: item.default,
                    }
                })
                $scope.param.param.invoiceTypeList = $scope.billParamSet[1].invoiceTypeList
            }
            $scope.param.param.usagePage = v
        }
        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('input.inputInvoice.collection') == -1) {
                sessionStorage.removeItem('collectionParam')
                sessionStorage.removeItem('collectionedParam')
                sessionStorage.removeItem('activeParam')
            } else {
                sessionStorage.setItem('activeParam', $scope.active)
            }
        })

        function handleParam() {
            if ($scope.active == 2) {
                // 去掉收集票据tab的字段
                $scope.param.param.verifyStatuList = []
                if ($scope.billType == 1) {
                    if ($scope.param.param.invoiceType || $scope.param.param.invoiceType === 0) {
                        $scope.param.param.invoiceTypeList = []
                        $scope.param.param.invoiceTypeList.push($scope.param.param.invoiceType)
                    } else {
                        $scope.param.param.invoiceTypeList = $scope.billParamSet[1].invoiceTypeList
                        $scope.param.param.invoiceType = ''
                    }
                    $scope.param.param.userName = '' // 去掉非增值税的字段
                    $scope.param.param.destination = ''
                    $scope.param.param.departure = ''
                }
                if ($scope.billType == 14) {
                    $scope.param.param.invoiceTypeList = $scope.billParamSet[$scope.billType].invoiceTypeList
                }
                if ($scope.billType != 1 && $scope.billType != 14) {
                    $scope.param.param.saleName = '' // 去掉增值税发票的字段
                    $scope.param.param.saleCreditCode = ''
                    $scope.param.param.invoiceStatus = ''
                    $scope.param.param.invoiceType = ''
                    $scope.param.param.invoiceTypeList = $scope.billParamSet[$scope.billType].invoiceTypeList
                }
            } else {
                // 去掉已使用票据tab的参数
                $scope.param.param.invoiceTypeList = []
                $scope.param.param.collectionStatus = ''
                $scope.param.param.turnOutType = ''
                $scope.param.param.zcssq = ''
                $scope.param.param.dkssq = ''
                $scope.param.param.orgIdList = $scope.orgIdListArr
            }
            // 解决搜索重置值的问题
            sessionStorage.removeItem('collectionParam')
            sessionStorage.removeItem('collectionedParam')
            sessionStorage.removeItem('activeParam')
        }
        $scope.currentOvatAmt = {}
        $scope.selectedRows = []
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedRows)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedRows.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            utils.loading('努力加载中...')
            httpRequest.post_getIvatBillStatics($scope.param.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            }).finally(()=>{
                utils.loaded()
            })
        }
        // 查询列表
        $scope.queryTaxInfo = function () {
            $scope.param = sessionStorage[paramStr] ? JSON.parse(sessionStorage[paramStr]) : $scope.param
            handleParam()
            utils.loading('努力加载中...')
            httpRequest.post_selectPageBill($scope.param).then((res) => {
                $scope.collectList = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total //
                $scope.param.pageNum = res.data.value.pageNum
                // 查询之后清空已经选择的数据
                $scope.selectedRows = []
                $scope.menuPermissions($scope.collectList)
            }).finally(()=>{
                utils.loaded()
            })
            getData()
        }
        // $scope.tabChange($scope.active)
        // 手动录入
        $scope.manuallyImport = () => {
            $uibModal
                .open({
                    template: manuallyImportModal,
                    openedClass: 'mod-modal mod-modal-lg',
                    animation: true,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'globalFn',
                        'formvalidateApi',
                        'logger',
                        '$timeout',
                        'obj',
                        function ($scope, $uibModalInstance, globalFn, formvalidateApi, logger, $timeout, obj) {
                            $scope.typeList = obj.list
                            $scope.fileName = '未选择任何文件'
                            $scope.flightDataListArr = [] //飞机航程信息明细
                            $scope.param = {
                                invoiceType: '0',
                                invoiceSource: 1,
                                billPhotoParamDTO: {
                                    base64Photo: '',
                                    batchNo: '',
                                    key: '',
                                    photoFileName: '',
                                },
                            }
                            let batchNo = ''
                            httpRequest.get_getBatchNo().then((res) => {
                                batchNo = res.data.value
                            })
                            $scope.getArea = function getArea(key) {
                                return httpRequest
                                    .get_getSysSfdqDmList({
                                        key,
                                    })
                                    .then((res) => res.data.value)
                            }

                            $timeout(() => {
                                $('#invoice-date').datetimepicker({
                                    autoclose: true,
                                    minView: 'month',
                                    language: 'zh-CN',
                                    format: 'yyyy-mm-dd',
                                    forceParse: 0,
                                    pickTime: false,
                                    pickerPosition: 'bottom-right',
                                })
                            })

                            $scope.cancel = function cancel() {
                                $uibModalInstance.close()
                            }
                            $scope.changeType = function changeType() {
                                $scope.fileName = '未选择任何文件'
                                $scope.param = {
                                    invoiceType: $scope.param.invoiceType,
                                    invoiceSource: 1,
                                    billPhotoParamDTO: {
                                        base64Photo: '',
                                        batchNo: batchNo,
                                        key: '',
                                        photoFileName: '',
                                    },
                                    flightDataList: [],
                                }
                                formvalidateApi.clear()
                                if ($scope.param.invoiceType == 104) $scope.param.taxRate = 0.03
                                if ($scope.param.invoiceType == 102 || $scope.param.invoiceType == 103) $scope.param.taxRate = 0.09
                                $timeout(() => {
                                    $('#invoice-date').datetimepicker({
                                        autoclose: true,
                                        minView: 'month',
                                        language: 'zh-CN',
                                        format: 'yyyy-mm-dd',
                                        forceParse: 0,
                                        pickTime: false,
                                        pickerPosition: 'bottom-right',
                                    })
                                })
                            }

                            $scope.setNumber = function setNumber(e) {
                                const inputNumber = $(e.currentTarget).val()
                                if (inputNumber.length == 1) {
                                    $scope.param.number = inputNumber.replace(/[^1-9]/g, '')
                                } else {
                                    $scope.param.number = inputNumber.replace(/\D/g, '')
                                }
                            }

                            $scope.completeInvoiceNumber = function completeInvoiceNumber() {
                                const length = 8 - $scope.param.invoiceNumber.length
                                for (let i = 0; i < length; i++) {
                                    $scope.param.invoiceNumber = `0${$scope.param.invoiceNumber}`
                                }
                            }

                            $scope.compute = function compute() {
                                $scope.param.ticketPrice = $scope.param.ticketPrice || 0
                                $scope.param.fuelSurcharge = $scope.param.fuelSurcharge || 0
                                $scope.param.constructionFee = $scope.param.constructionFee || 0
                                $scope.param.otherTaxes = $scope.param.otherTaxes || 0
                                if ($scope.param.invoiceType == 102) {
                                    $scope.param.totalTaxamt = globalFn.Mul(0.09, globalFn.Div(globalFn.Add($scope.param.ticketPrice, $scope.param.fuelSurcharge), 1.09))
                                    $scope.param.totalTaxamt = Math.round($scope.param.totalTaxamt * Math.pow(10, 2)) / Math.pow(10, 2)
                                    $scope.param.totalSum = $scope.param.ticketPrice + $scope.param.fuelSurcharge + $scope.param.constructionFee + $scope.param.otherTaxes
                                    $scope.param.totalSum = Math.round($scope.param.totalSum * Math.pow(10, 2)) / Math.pow(10, 2)
                                } else if ($scope.param.invoiceType == 103 || $scope.param.invoiceType == 104) {
                                    $scope.param.totalTaxamt = globalFn.Mul($scope.param.taxRate, globalFn.Div($scope.param.ticketPrice, globalFn.Add($scope.param.taxRate, 1)))
                                    $scope.param.totalTaxamt = Math.round($scope.param.totalTaxamt * Math.pow(10, 2)) / Math.pow(10, 2)
                                } else if ($scope.param.invoiceType == 105 || $scope.param.invoiceType == 105) {
                                    if (Number($scope.param.number) < 1 || isNaN(Number($scope.param.number))) {
                                        $scope.param.number = 1
                                    }
                                    if ($scope.param.oneAmount == null || $scope.param.oneAmount < 0) {
                                        $scope.param.oneAmount = null
                                        $scope.param.totalSum = null
                                        return
                                    }
                                    $scope.param.totalSum = ($scope.param.oneAmount * $scope.param.number).toFixed(2)
                                    $('.tyde-totalSum2').removeClass('has-error')
                                    $('.tyde-totalSum2').find('.erro_msg').empty()
                                }
                            }
                            $scope.clickValid = true
                            $scope.ok = function ok(str) {
                                const reg = /^([01]\d|2[01234]):([0-5]\d|60)$/
                                if ($scope.param.getTime && !reg.test($scope.param.getTime)) {
                                    if ($scope.param.invoiceType == '108') return logger.logError('开始时间格式错误,格式应为HH:MM')
                                    return logger.logError('上车时间格式错误,格式应为HH:MM')
                                }
                                if ($scope.param.offTime && !reg.test($scope.param.offTime)) {
                                    if ($scope.param.invoiceType == '108') return logger.logError('结束时间格式错误,格式应为HH:MM')
                                    return logger.logError('下车时间格式错误,格式应为HH:MM')
                                }

                                const numberreg = /^[0-9]*$/
                                const numberReg8 = /^\d{8}$/
                                const numberReg10 = /^\d{10}$/
                                const numberReg12 = /^\d{12}$/
                                const numberReg20 = /^\d{20}$/
                                const dateFormat = /^((?:19|20)\d\d)-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
                                if ($scope.param.invoiceDate && !dateFormat.test($scope.param.invoiceDate)) {
                                    return logger.logError('输入日期不合法,格式应为YYYY-MM-DD')
                                }
                                if ($scope.param.invoiceType < 61 && $scope.param.invoiceCode && (!(numberReg10.test($scope.param.invoiceCode) || numberReg12.test($scope.param.invoiceCode)) || !numberreg.test($scope.param.invoiceCode))) {
                                    return logger.logError('代码位数为10位、12位')
                                }
                                if ($scope.param.invoiceType < 61 && $scope.param.invoiceNumber && (!numberReg8.test($scope.param.invoiceNumber) || !numberreg.test($scope.param.invoiceNumber))) {
                                    return logger.logError('号码位数为8位')
                                }
                                if (($scope.param.invoiceType == 66 || $scope.param.invoiceType == 67) && $scope.param.invoiceCode && (!(numberReg10.test($scope.param.invoiceCode) || numberReg12.test($scope.param.invoiceCode)) || !numberreg.test($scope.param.invoiceCode))) {
                                    return logger.logError('代码位数为10位、12位')
                                }
                                if (($scope.param.invoiceType == 66 || $scope.param.invoiceType == 67) && $scope.param.invoiceNumber && (!numberReg8.test($scope.param.invoiceNumber) || !numberreg.test($scope.param.invoiceNumber))) {
                                    return logger.logError('号码位数为8位')
                                }
                                if (($scope.param.invoiceType == '61' || $scope.param.invoiceType == '62' || $scope.param.invoiceType == '64') && $scope.param.invoiceNumber && (!numberReg20.test($scope.param.invoiceNumber) || !numberreg.test($scope.param.invoiceNumber))) {
                                    return logger.logError('号码位数为20位')
                                }
                                if ($scope.param.invoiceType == '64' && $scope.param.invoiceNumber && (!numberReg20.test($scope.param.invoiceNumber) || !numberreg.test($scope.param.invoiceNumber))) {
                                    return logger.logError('数电发票号码位数为20位')
                                }
                                if ($scope.param.invoiceType == '64' && ($scope.param.adValoremTotal == '0' || $scope.param.adValoremTotal == '0.00')) {
                                    logger.logError('价税合计必填')
                                    return
                                }
                                const flag = formvalidateApi.run()
                                if (flag && $scope.clickValid) {
                                    $scope.clickValid = false
                                    // console.log($scope.param)
                                    // return
                                    httpRequest.post_saveBill($scope.param).then(
                                        () => {
                                            $scope.clickValid = true
                                            logger.logSuccess('录入成功！')
                                            if (str == 'continue') {
                                                $scope.changeType()
                                                return
                                            }
                                            $uibModalInstance.close()
                                        },
                                        () => {
                                            $scope.clickValid = true
                                        }
                                    )
                                }
                            }
                            // 手工录入增加飞机航程信息明细
                            $scope.addFlightinforDetails = function () {
                                $uibModal
                                    .open({
                                        template: flightinforDetailModal,
                                        openedClass: 'mod-modal mod-modal-lg',
                                        animation: true,
                                        controller: [
                                            '$scope',
                                            '$uibModalInstance',
                                            'logger',
                                            'httpRequest',
                                            'items',
                                            function ($scope, $uibModalInstance, logger, httpRequest, items) {
                                                // $scope.dictData = items
                                                $scope.flightDataList = {
                                                    flightFrom: '',
                                                    flightTo: '',
                                                    flightNumber: '',
                                                    seatClass: null,
                                                    flightDate: '',
                                                    flightTime: '',
                                                    fareBasis: null,
                                                    allow: '',
                                                }
                                                $scope.cancel = function cancel() {
                                                    $uibModalInstance.dismiss()
                                                }
                                                $scope.ok = function ok() {
                                                    $uibModalInstance.close($scope.flightDataList)
                                                }
                                            },
                                        ],
                                        resolve: {
                                            items() {},
                                        },
                                    })
                                    .result.then((res) => {
                                        $scope.flightDataListArr.push(res)
                                        $scope.param.flightDataList = $scope.flightDataListArr
                                    })
                            }
                            //手工附件上传
                            $scope.manuallyUploadFiles = function (files, errorFiles) {
                                // 取消清空图片
                                if ($scope.param) {
                                    $scope.param.billPhotoParamDTO.key = ''
                                    $scope.param.billPhotoParamDTO.photoFileName = ''
                                    $scope.fileName = '未选择任何文件'
                                }
                                if (files[0]) {
                                    const size = files[0].size
                                    let nameArr = files[0].name.split('.')
                                    const suffix = nameArr[nameArr.length - 1]
                                    if (suffix === 'pdf' || suffix === 'ofd') {
                                        //pdf文件大小不能超过10mb
                                        if (size > 1024 * 1024 * 10) {
                                            logger.logError('上传非图片文件大小不能超过10MB')
                                            $scope.param.billPhotoParamDTO.key = ''
                                            $scope.param.billPhotoParamDTO.photoFileName = ''
                                            $scope.fileName = '未选择任何文件'
                                            return
                                        }
                                    } else {
                                        //图片大小不能超过50mb
                                        if (size > 1024 * 1024 * 50) {
                                            logger.logError('上传图片文件大小不能超过50MB')
                                            $scope.param.billPhotoParamDTO.key = ''
                                            $scope.param.billPhotoParamDTO.photoFileName = ''
                                            $scope.fileName = '未选择任何文件'
                                            return
                                        }
                                    }

                                    $scope.fileName = ''
                                    files[0] ? ($scope.fileName = files[0].name) : ($scope.fileName = errorFile[0].name)

                                    $scope.param.billPhotoParamDTO.key = $scope.fileName
                                    $scope.param.billPhotoParamDTO.photoFileName = $scope.fileName
                                    $scope.reader = new FileReader() //创建一个FileReader接口
                                    $scope.reader.readAsDataURL(files[0] || errorFile[0]) //FileReader的方法，转成base64文件流
                                    $scope.reader.onload = function (ev) {
                                        $scope.param.billPhotoParamDTO.base64Photo = ev.target.result
                                    }
                                }
                            }
                        },
                    ],
                    resolve: {
                        obj() {
                            return {
                                list: $scope.dictData.ivat_inv_type,
                            }
                        },
                    },
                })
                .result.then(() => {
                    $scope.queryTaxInfo()
                })
        }

        // 表格下拉框配置
        $scope.tableDropdownConfig = [
            {
                label: '校对',
                handler(item) {
                    $scope.batchProofread([item])
                },
                async showWhile(item, hasPermit) {
                    // hasPermit('invoice_proofread')
                    item.checkHasPermit = await $scope.hasPermitHandle(item.orgId, 'invoice_proofread')
                    const proofreadPermit = $scope.hasPermitHandle(item.orgId, 'invoice_proofread')
                    return proofreadPermit && item.proofreadStatus != 6 && $scope.active == 1
                },
            },
            {
                label: '详情',
                handler(item) {
                    const params = {
                        ...$scope.param,
                    }
                    httpRequest.post_selectPageBill(params).then((res) => {
                        $uibModal.open({
                            template: modalList,
                            controller: 'CollectionModalListCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail collection-invoice-detail',
                            resolve: {
                                items1() {
                                    const data = {
                                        modalListData: res && res.data && res.data.value && res.data.value.list && res.data.value.list.map((item) => item.invoiceId),
                                        currentInvoicId: item.invoiceId,
                                        total: res && res.data && res.data.value && res.data.value.total,
                                        fromWhere: 1, // 发票收集
                                        param: $scope.param.param,
                                        originalPageNum: $scope.param.pageNum,
                                        pageSize: $scope.param.pageSize,
                                    }
                                    return data
                                },
                            },
                        })
                    })
                },
                async showWhile(item, hasPermit) {
                    const detailPermit = await $scope.hasPermitHandle(item.orgId, 'collection_detail')
                    return (
                        //hasPermit('collection_detail')
                        detailPermit && ((item.verifyStatus != 8 && item.verifyStatus != 0) || $scope.active != 1)
                    )
                },
            },
            {
                label: '删除',
                handler(item, index) {
                    // $scope.modalSureDeleteInvoice(item, index)
                    $scope.batchDelete([item])
                },
                async showWhile(item, hasPermit) {
                    item.deleteHasPermit = await $scope.hasPermitHandle(item.orgId, 'invoice_collect_delete')
                    const deletePermit = await $scope.hasPermitHandle(item.orgId, 'invoice_collect_delete')
                    return deletePermit && $scope.active == 1
                },
            },
            {
                label: '提交',
                handler(item) {
                    $scope.batchSubmit([item])
                },
                async showWhile(item, hasPermit) {
                    item.submitHasPermit = await $scope.hasPermitHandle(item.orgId, 'invoice_collect_delete')
                    const collectionSubmitPermit = await $scope.hasPermitHandle(item.orgId, 'collection_submit')
                    return collectionSubmitPermit && item.proofreadStatus == 6 && $scope.active == 1
                },
            },
            {
                label: '查验',
                handler(item) {
                    $scope.check(item)
                },
                showWhile(i) {
                    return (i.verifyStatus == 8 || i.verifyStatus == 0) && $scope.active == 1
                },
            },
        ]
        // 权限控制
        $scope.hasPermitHandle = async function (dataOrgId, hasPermit) {
            if (!$scope.allMenuPermissions) return
            // 默认 false
            $scope.hasPermitFlag = false
            // 对应菜单数据权限
            $scope.CorrMenuPermiss = $scope.allMenuPermissions.filter((item) => {
                return item.orgId == dataOrgId
            })
            if (!$scope.CorrMenuPermiss.length) return false
            functionListChild($scope.CorrMenuPermiss[0].functionList, currentRoutAddress, hasPermit, (item, currentRout, hasPermit) => {
                if (item.url == currentRout) {
                    // console.log('存在路由')
                    return true
                } else if (item.functionCode == hasPermit) {
                    // console.log('存在对应权限')
                    $scope.hasPermitFlag = true
                    return false
                }
                return false
            })
            return $scope.hasPermitFlag
        }
        // 校验是否有权限
        let functionListChild = function (functionList, currentRout, hasPermit, cb) {
            for (const i in functionList) {
                let flat = cb(functionList[i], currentRout, hasPermit)
                if (functionList[i].childFuncList && flat) {
                    functionListChild(functionList[i].childFuncList, currentRout, hasPermit, cb)
                }
            }
        }
        // 获取当前登陆用户的菜单权限
        $scope.menuPermissions = function (collectList) {
            let allOrgIdListArr = []
            angular.forEach(collectList, (item, index) => {
                allOrgIdListArr.push(item.orgId)
            })
            const newAllOrgIdListArr = (arr) => [...new Set(arr)]
            httpRequest.post_getFunctionListByUserAndOrgIds(newAllOrgIdListArr(allOrgIdListArr)).then((res) => {
                $scope.allMenuPermissions = res.data.value
            })
        }
        // 批量校对
        $scope.batchProofread = function batchProofread(invoice) {
            const selectedRows = invoice || $scope.selectedRows
            console.log(selectedRows)
            if (selectedRows.length === 0) {
                return logger.logError('请选择要校对的数据行')
            } else if (!currentOrgAuthority(selectedRows, 'invoice_proofread', '校对')) {
                return
            }
            for (const key in selectedRows) {
                if (selectedRows[key].proofreadStatus == 6) return logger.logError('已选择数据中存在不可校对数据！')
            }
            $uibModal
                .open({
                    template: modalInvoiceDetailTmplate,
                    controller: 'modalInvoiceDetailCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail',
                    resolve: {
                        items1() {
                            const data = {
                                uploadListData: selectedRows,
                                currentInvoicId: selectedRows[0].invoiceId,
                            }
                            return data
                        },
                    },
                })
                .result.then(() => {
                    $scope.queryTaxInfo()
                })
        }
        //批量提交
        $scope.batchSubmit = function (arr) {
            const selectedRows = arr || $scope.selectedRows
            if (!selectedRows.length) {
                return logger.logError('请选择要提交的数据行')
            } else if (!currentOrgAuthority(selectedRows, 'collection_submit', '提交')) {
                return
            }
            // console.log($scope.selectedRows)
            sweetalert.confirm('提交提醒', '确认提交所选的发票信息？').then(() => {
                const invoiceIdList = []
                selectedRows.forEach((row) => {
                    invoiceIdList.push(row.invoiceId)
                })
                httpRequest.post_batchSubmitBill(invoiceIdList).then(() => {
                    logger.logSuccess('提交成功，可在“已使用票据”及“发票管理”页面中查看！')
                    $scope.queryTaxInfo()
                })
            })
            // $scope.modalSureDeleteInvoice($scope.selectedRows)
        }
        // 批量删除
        $scope.batchDelete = function (item) {
            const selectedRows = item || $scope.selectedRows
            if (!selectedRows.length) {
                return logger.logError('请选择要删除的数据行')
            } else if (!currentOrgAuthority(selectedRows, 'invoice_collect_delete', '删除')) {
                return
            }
            // console.log($scope.selectedRows)
            sweetalert.confirm('删除提醒', '确认删除所选的发票信息？').then(() => {
                const invoiceIdList = []
                selectedRows.forEach((row) => {
                    invoiceIdList.push(row.invoiceId)
                })
                httpRequest.post_batchDeleteBill(invoiceIdList).then((res) => {
                    const errorData = res.data.value
                    if (errorData.length) {
                        logger.logError(errorData[0].errorMsg)
                    } else {
                        logger.logSuccess('删除成功！')
                    }
                    $scope.queryTaxInfo()
                })
            })
            // $scope.modalSureDeleteInvoice($scope.selectedRows)
        }
        //批量查验
        $scope.check = function (item) {
            const invoiceIds = []
            if (item) {
                invoiceIds.push(item.invoiceId)
            } else if (!$scope.selectedRows.length) {
                return logger.logError('请选择要查验的数据行')
            } else {
                $scope.selectedRows.forEach((i) => {
                    // 查验状态放开查验 不校验
                    //   if (i.verifyStatus == 8 || i.verifyStatus == 0)
                    //     invoiceIds.push(i.invoiceId);
                    invoiceIds.push(i.invoiceId)
                })
            }
            //   if (!invoiceIds.length)
            //     return logger.logError('存在无需查验的发票，请取消后再查验');
            utils.loading('正在查验中，请稍后查看查验结果')
            httpRequest.post_batchVerifyBill(invoiceIds).then((res) => {
                utils.loaded()
                if (res.data.value.length) {
                    const params = {
                        sourceCount: invoiceIds.length,
                        errorCount: res.data.value.length,
                        list: res.data.value,
                        title: '查验',
                    }
                    resultTipService.openErrorModal(params, $scope.queryTaxInfo)
                } else {
                    logger.logSuccess(`查验成功${invoiceIds.length}张票据`)
                    $scope.queryTaxInfo()
                }
            })
            // console.log(item)
            // console.log($scope.selectedRows)
        }
        // 当前机构批量操作的权限
        function currentOrgAuthority(selectedRows, hasPermit, tipsMsg) {
            try {
                angular.forEach(selectedRows, (item, index) => {
                    switch (true) {
                        case hasPermit == 'invoice_proofread':
                            if (!item.checkHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                        case hasPermit == 'invoice_collect_delete':
                            if (!item.deleteHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                        case hasPermit == 'collection_submit':
                            if (!item.submitHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                    }
                })
            } catch (e) {
                if (e) {
                    return false
                }
            }
            return true
        }
        $scope.uploadFiles = function uploadFiles(v) {
            $uibModal
                .open({
                    template: v == 5 ? modalUploadListAsync : modalUploadList,
                    controller: 'modalUploadListCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-detail',
                    resolve: {
                        items1() {
                            return {
                                uploadType: v,
                            }
                        },
                    },
                })
                .result.then(() => {
                    $scope.queryTaxInfo()
                })
        }
        // 导出
        $scope.exportInvoice = function () {
            handleParam()
            const reqObj = $.extend({}, $scope.param.param, {
                idList: $scope.selectedRows.map((x) => x.invoiceId),
            })
            let _url = `${host.etcloudIvatApp}manage/ivatBill/exportToExcel`
            if ($scope.active == 1) {
                _url = `${host.etcloudIvatApp}manage/ivatBill/importToExcel`
                //httpRequest.get_importIvatBillToExcel(reqObj)
            }
            // else {
            //     httpRequest.get_exportIvatBillToExcel(reqObj)
            // }
            _url = `${_url}?accessToken=${localStorage.getItem('id_token')}`
            for (let i in $scope.param.orderMap) {
                reqObj.sortField = i + ':' + $scope.param.orderMap[i]
            }
            utils.post_downLoad(reqObj, _url)
        }

        $scope.searchList = function () {
            $scope.queryTaxInfo()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                paramStr,
                JSON.stringify({
                    orderMap: $scope.param.orderMap,
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: sessionStorage[paramStr]
                        ? JSON.parse(sessionStorage[paramStr]).param
                        : {
                              invoiceType: '',
                              invoiceCode: '',
                              invoiceDateStart: '',
                              invoiceDateEnd: '',
                              verifyStatuList: [],
                              taxRate: '',
                              adValoremTotalStart: '',
                              createUser: '',
                              invoiceStatus: '',
                              invoiceSource: '',
                              saleName: '',
                              saleCreditCode: '',
                              userName: '',
                              destination: '',
                              departure: '',
                              deductionFlag: '',
                              passengerFlag: '',
                              claimNumber: '',
                              usageStatus: '',
                              usagePage: $scope.active,
                              collectionStatus: '', // tab2
                              turnOutType: '', // tab2
                              zcssq: '', // tab2
                              dkssq: '', // tab2
                              projectId: '',
                              projectCode: '',
                              transferOutSign: '',
                              transferAmount: '',
                              orgIdList: $scope.orgIdListArr,
                              comparisonStatus: '',
                              paymentDate: '',
                          },
                })
            )
            $scope.queryTaxInfo()
        }
        $scope.totalItems = 0 // 组件初始化设置总页数
        // $scope.queryTaxInfo()
        // 表头排序
        $scope.orderMap = initSortService(paramStr)
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem(paramStr, JSON.stringify($scope.param))
            $scope.queryTaxInfo()
        }
        $scope.updateTheEntryMonth = function () {
            if (!$scope.selectedRows.length) return logger.logError('请选择数据')
            let isPort = $scope.selectedRows.some((x) => x.billSource == '2')
            if (isPort) return logger.logError('更新入账月份仅支持录入方式为非:“接口”,请检查')
            let invoiceIdList = $scope.selectedRows.map((x) => x.invoiceId)
            $uibModal
                .open({
                    template: updateMonthModal,
                    backdrop: 'static',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        '$filter',
                        'logger',
                        'modalData',
                        ($scope, $uibModalInstance, httpRequest, $filter, logger, modalData) => {
                            const { invoiceIdList } = modalData
                            $scope.datePickerConfig = {
                                endDate: new Date(),
                                format: 'yyyymm',
                                startView: 'year',
                                minView: 'year',
                            }
                            $scope.param = {
                                invoiceIdList,
                                paymentMonth: '',
                            }
                            // 确定
                            $scope.ok = function ok() {
                                if (!$scope.param.paymentMonth) return logger.logError('请选择入账月份')
                                httpRequest.post_batchUpdateBillPaymentMonth($scope.param).then((res) => {
                                    const { failNum, successNum, totalNum } = res.data.value
                                    logger.logSuccess(`成功${successNum}条，失败${failNum}条。`)
                                    $uibModalInstance.close()
                                })
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    openedClass: 'mod-modal mod-modal-lg mod-modal-big',
                    resolve: {
                        modalData() {
                            return { invoiceIdList }
                        },
                    },
                })
                .result.then((data) => {
                    $scope.queryTaxInfo()
                })
        }
    }
}

collectionListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'initSortService', 'exportSettingService', 'getOvatAmtService', 'resultTipService', '$location']
export default collectionListCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/collectionListCtrl.js